import { Condition, ConditionAttribute, ConditionOperator } from 'shared/types/graphql';

export const getConditionHasValue = (condition: Pick<Condition, 'attribute' | 'operator' | 'operand'>): boolean => {
  const { value } = condition.operand;

  if (condition.attribute === ConditionAttribute.PetAgeInYears && condition.operator !== ConditionOperator.Between) {
    return typeof value === 'number' && value > 0;
  }

  return Array.isArray(value) && !!value.length;
};
